import {
	SET_ACTIVE_GOODY,
	SET_ACTIVE_GOODIES_WITH_SHUFFLE,
	SET_SHUFFLE_GOODIES,
} from '../constants';

import { setActiveGoodies } from '../utils/initialize';

const initialState = setActiveGoodies();

const activeGoodies = (state = initialState, action) => {
	switch (action.type) {
		case SET_ACTIVE_GOODY:
			return {
				...state,
				active: {
					...state.active,
					[action.payload.type]: action.payload.id,
				},
			};
		case SET_ACTIVE_GOODIES_WITH_SHUFFLE:
			return {
				...state,
				shuffle: action.payload.shuffle,
				active: action.payload.activeGoodies,
			};
		case SET_SHUFFLE_GOODIES:
			return {
				...state,
				shuffle: action.payload.shuffle,
			};
		default:
			return state;
	}
};

export default activeGoodies;



// WEBPACK FOOTER //
// ./src/reducers/activeGoodies.js